import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MessageThread, MESSAGE_THREAD_TYPE } from '@univacity/shared/types';
import { AngularUiModule } from '@univacity/angular/ui';
import { AngularDatasModule } from '@univacity/angular/datas';

@Component({
  selector: 'un-message-thread-cover',
  imports: [
    CommonModule,
    NgOptimizedImage,
    AngularUiModule,
    AngularDatasModule,
  ],
  templateUrl: './message-thread-cover.component.html',
  styleUrls: ['./message-thread-cover.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageThreadCoverComponent {
  @Input() thread: MessageThread;

  TYPE = MESSAGE_THREAD_TYPE;
}
